import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/auth/context';
import type { LoginRedirectState } from '@/auth/redirect';

/**
 * The route guard: unauthenticated ⇒ `/login`, carrying the interrupted route.
 *
 * A layout route rather than a wrapper per page, so "which routes need a session" is one
 * readable block in `App.tsx` instead of a decision repeated five times.
 *
 * **It cannot loop.** `/login` is outside the guard, so a 401 that arrives while the player
 * is already at `/login` changes nothing; and `readRedirectTarget` refuses to send anyone
 * back to `/login` even if the state says so.
 */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'signed_out') {
    const state: LoginRedirectState = { from: `${location.pathname}${location.search}` };
    return <Navigate to="/login" state={state} replace />;
  }

  return <Outlet />;
}
